import { Action } from 'redux';

import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { LaunchRevisionHistory } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface RevisionHistoryAction extends Action {
  content: IContentInfo;
}

export function launchRevisionHistory(content: IContentInfo): RevisionHistoryAction {
  return {
    type: LaunchRevisionHistory,
    content
  };
}

export const isRevisionHistoryAction = isActionFactory<RevisionHistoryAction>(LaunchRevisionHistory);
